module.exports = __webpack_public_path__ + "819f56653a4197a7959c41ddfc8ff69b.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/Pili/AppData/Roaming/npm/~/pink/css/fonts/Inconsolata/Inconsolata-Bold.ttf
// module id = 346
// module chunks = 0